import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputStammdatenAttachementModify<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: name */
  name?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputStammdatenAttachementModify> = {
  code: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputStammdatenAttachementModifyEntityDefinition: EntitiyDefinition<InputStammdatenAttachementModify> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputStammdatenAttachementModify',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
